import React from 'react';
import PropTypes from 'prop-types';
import { FaLinkedinIn, FaFacebookF, FaTwitter } from 'react-icons/fa';
import styles from './AuthorSocialShare.module.scss';

const AuthorSocialShare = ({ twitter, facebook, linkedIn }) => (
  <ul className={styles.social_share}>
    {twitter && (
      <li className={styles.social_share_item}>
        <a className={styles.social_share_icon} href={twitter} target="_blank" rel="noreferrer">
          <FaTwitter />
        </a>
      </li>
    )}
    {facebook && (
      <li className={styles.social_share_item}>
        <a className={styles.social_share_icon} href={facebook} target="_blank" rel="noreferrer">
          <FaFacebookF />
        </a>
      </li>
    )}
    {linkedIn && (
      <li className={styles.social_share_item}>
        <a className={styles.social_share_icon} href={linkedIn} target="_blank" rel="noreferrer">
          <FaLinkedinIn />
        </a>
      </li>
    )}
  </ul>
);
export default AuthorSocialShare;

AuthorSocialShare.defaultProps = {
  twitter: '',
  facebook: '',
  linkedIn: '',
};

AuthorSocialShare.propTypes = {
  twitter: PropTypes.string,
  facebook: PropTypes.string,
  linkedIn: PropTypes.string,
};
